import { render, staticRenderFns } from "./CreatePlusBaseTemplateListPage.vue?vue&type=template&id=6f3b9cf4&scoped=true&"
import script from "./CreatePlusBaseTemplateListPage.vue?vue&type=script&lang=js&"
export * from "./CreatePlusBaseTemplateListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b9cf4",
  null
  
)

export default component.exports